export default "__VITE_ASSET__BqonCG4U__"